<!-- Modal -->
<div class="modal love-it-wraps" id="reviewModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="false"
    style="display: block;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content review-modal">
            <div class="modal-header border-0 justify-content-between position-relative px-4">
                <h5 class="modal-title"> Tell Us How You Feel!</h5>
                <!-- custom close -->
                <i class="fa-solid fa-xmark cursor-pointer" (click)="closePopup()"></i>
            </div>
            <div class="modal-body">
                <!-- product info -->
                <div class="d-flex align-items-start gap-3 mb-3">
                    <h6>{{ data.product_name }}</h6>
                </div>
                <!-- form -->
                <form class="review-form mb-3" [formGroup]="loveItForm" (submit)="submit()">
                    <div class="mb-2">
                        <input class="form-control custom-input" type="text" placeholder="First Name"
                            formControlName="first_name" required>
                        <span class="validation-error"
                            *ngIf="loveItForm.get('first_name').invalid &&(loveItForm.get('first_name').dirty ||loveItForm.get('first_name').touched ||isSubmitClicked)">
                            First name is required
                        </span>
                    </div>
                    <div class="mb-2">
                        <input class="form-control custom-input" type="email" placeholder="Email"
                            formControlName="email_address">
                        <div class="validation-error"
                            *ngIf="loveItForm.get('email_address').hasError('email') &&!loveItForm.get('email_address').hasError('required') &&(loveItForm.get('email_address').dirty ||loveItForm.get('email_address').touched ||isSubmitClicked)">
                            Invalid email address.
                        </div>
                        <span class="validation-error"
                            *ngIf="loveItForm.get('email_address').hasError('required') &&(loveItForm.get('email_address').dirty ||loveItForm.get('email_address').touched ||isSubmitClicked)">
                            Email is required.
                        </span>
                    </div>
                    <div class="mb-2">
                        <input class="form-control custom-input" type="text" placeholder="Comment"
                            formControlName="comments">
                        <span class="validation-error"
                            *ngIf="loveItForm.get('comments').invalid &&(loveItForm.get('comments').dirty ||loveItForm.get('comments').touched ||isSubmitClicked)">
                            Comments are required.
                        </span>
                    </div>
                    <div class="text-center py-3">
                        <h6> High Five Us With 5 Stars! </h6>
                        <div (mouseleave)="selectedRating = hoverRating">
                            <i *ngFor="let star of stars" class="fas fa-star fa-sm" [ngClass]="getStarClass(star)"
                                (mousemove)="onMouseMove($event, star)" (click)="selectedRating = hoverRating">
                            </i>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mb-2">
                        <button type="submit" class="btn btn-submit">SUBMIT</button>
                    </div>
                    <div class="divider mb-3"></div>
                    <div>
                        <h6 class="text-center py-3"> SHARE US WITH YOUR FRIENDS
                        </h6>
                        <div class="social-row">
                            <a class="social-box cursor-pointer facebook" (click)="share('facebook')" aria-label="Facebook"
                                target="_blank" rel="noopener">
                                <i class="fa-brands fa-facebook-f"></i>
                            </a>
                            <a class="social-box cursor-pointer twitter" (click)="share('twitter')" aria-label="Twitter (X)"
                                target="_blank" rel="noopener">
                                <i class="fa-brands fa-x-twitter"></i>
                            </a>
                            <a class="social-box cursor-pointer  linkedin" (click)="share('linkedin')" aria-label="LinkedIn"
                                target="_blank" rel="noopener">
                                <i class="fa-brands fa-linkedin-in"></i>
                            </a>
                            <a class="social-box cursor-pointer pinterest" (click)="share('pinterest')" aria-label="Pinterest"
                                target="_blank" rel="noopener">
                                <i class="fa-brands fa-pinterest-p"></i>
                            </a>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>